export default "__VITE_ASSET__BsLc7xea__"